import { useState, useEffect } from 'react'
import { Box, HStack } from '@chakra-ui/react'
import { useSprings } from 'react-spring'

import { AnimatedBox, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

interface Props {
  onClick: (index: number) => void
  length: number
  index: number
  id?: string
}

function CarouselBar({
  length,
  index,
  onClick,
  id,
}: Props): React.ReactElement {
  const [previousIndex, setPreviousIndex] = useState(index)

  useEffect(() => {
    setPreviousIndex(index)
  }, [index])

  const springs = useSprings(
    length,
    Array(length)
      .fill(0)
      .map((_, _index) => {
        const spring = {
          transform: `translate3d(${_index > index ? '-' : ''}100%, 0, 0)`,
          opacity: 0,
          config: DEFAULT_SPRING_CONFIG,
          immediate: false,
        }

        if (index !== _index && previousIndex !== _index) {
          return spring
        }

        const direction = index - previousIndex

        if (index === _index) {
          spring.opacity = 1
          if (direction > 0) {
            spring.transform = 'translate3d(100%, 0, 0)'
          } else if (direction < 0) {
            spring.transform = 'translate3d(-100%, 0, 0)'
          } else {
            spring.transform = 'translate3d(0%, 0, 0)'
          }
        }

        if (direction > 0) {
          spring.transform = 'translate3d(-100%, 0, 0)'
        } else if (direction < 0) {
          spring.transform = 'translate3d(100%, 0, 0)'
        }

        return spring
      }),
  )

  return (
    <HStack
      spacing={{
        base: 2,
        sm: 4,
      }}
      sx={{ pt: '24px', justifyContent: 'center' }}
      id={id}
    >
      {springs.map((styles, index) => {
        return (
          <Box
            key={`${index}`}
            as="figure"
            sx={{
              position: 'relative',
              overflow: 'hidden',
              w: {
                base: 14,
                sm: 24,
              },
              h: 2,
              borderRadius: 'full',
              bg: 'gray.300',
              cursor: 'pointer',
              transform: 'translate3d(0, 0, 0)',
            }}
            onClick={() => onClick(index)}
          >
            <AnimatedBox
              style={styles}
              sx={{
                position: 'absolute',
                w: 'full',
                h: 'full',
                bg: 'primary.400',
              }}
            />
          </Box>
        )
      })}
    </HStack>
  )
}

export default CarouselBar
